import React from "react";
import { IconChevronRight } from "@tabler/icons-react";
import styles from "./RecordCategoryCard.module.css";

export interface RecordCategoryCardProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> {
  icon: React.ReactNode;
  iconBg: string;
  label: string;
  count: number;
  /** Shown under the divider, e.g. "None added yet" (count 0) or "Latest 12 Feb 2025" (count > 0). Omitted entirely when not provided. */
  stateMessage?: string;
  /** "grid" = 2-col stacked cell with divider + state message. "row" = full-width row with trailing chevron. */
  variant?: "grid" | "row";
  onClick?: () => void;
}

const RecordCategoryCard: React.FC<RecordCategoryCardProps> = ({
  icon,
  iconBg,
  label,
  count,
  stateMessage,
  variant = "grid",
  onClick,
  className = "",
  ...rest
}) => {
  if (variant === "row") {
    return (
      <button
        type="button"
        className={`${styles.row} ${className}`}
        onClick={onClick}
        {...rest}
      >
        <div className={styles.iconTile} style={{ background: iconBg }}>
          {icon}
        </div>
        <div className={styles.rowTextWrap}>
          <span className={styles.label}>{label}</span>
          <span className={styles.count}>{count}</span>
        </div>
        <IconChevronRight
          size={24}
          color="#2A2A2A"
          className={styles.chevron}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`${styles.cell} ${className}`}
      onClick={onClick}
      {...rest}
    >
      <div className={styles.topRow}>
        <div className={styles.iconTile} style={{ background: iconBg }}>
          {icon}
        </div>
        <div className={styles.textCol}>
          <span className={styles.label}>{label}</span>
          <span className={styles.count}>{count}</span>
        </div>
      </div>
      {stateMessage && (
        <>
          <div className={styles.divider} />
          <span className={styles.stateMessage}>{stateMessage}</span>
        </>
      )}
    </button>
  );
};

export default RecordCategoryCard;
